import { groupLabel } from '@/components/usergroup/group'
import React from "react"
import "./UserGroupMultiSelect.css"

export interface SimpleUserGroup {
  id: string
  name: string
  namespaceName?: string
  isRelated?: boolean
}

type Props = {
  groups: SimpleUserGroup[]
  selectedIds: string[]
  onChange: (nextSelectedIds: string[]) => void
  disabled?: boolean
}

export function UserGroupMultiSelect({ groups, selectedIds, onChange, disabled }: Props) {
  function toggle(id: string) {
    if (disabled) return

    const next = selectedIds.includes(id)
      ? selectedIds.filter((x) => x !== id)
      : [...selectedIds, id]

    onChange(next)
  }

  return (
    <div className="ugms" role="group" aria-label="Groups">
      {groups.map((g) => {
        const active = selectedIds.includes(g.id)
        return (
          <button
            key={g.id}
            type="button"
            className={`ugms__btn ${active ? "is-active" : ""}`}
            aria-pressed={active}
            disabled={disabled}
            onClick={() => toggle(g.id)}
          >
            {groupLabel(g)}
          </button>
        )
      })}
    </div>
  )
}